module.exports = __webpack_public_path__ + "img/ISTP.247a223e.png";